import { useEffect } from "react";

const SITE = "https://troideo.com";

function setMeta(selector, attr, value, create) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

export default function Seo({ title, description, path }) {
  useEffect(() => {
    const url = `${SITE}${path}`;
    if (title) document.title = title;
    if (description) {
      setMeta('meta[name="description"]', "content", description, () => {
        const m = document.createElement("meta");
        m.setAttribute("name", "description");
        return m;
      });
    }
    setMeta('link[rel="canonical"]', "href", url, () => {
      const l = document.createElement("link");
      l.setAttribute("rel", "canonical");
      return l;
    });
    [["og:title", title], ["og:description", description], ["og:url", url]].forEach(([p, v]) => {
      if (!v) return;
      setMeta(`meta[property="${p}"]`, "content", v, () => {
        const m = document.createElement("meta");
        m.setAttribute("property", p);
        return m;
      });
    });
  }, [title, description, path]);
  return null;
}
